var _circle, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExplore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 6.5,
    r: 6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.49986 1C8.49986 1 7.79124 2.22241 7.99986 3C8.21453 3.80013 9.28519 3.69987 9.49986 4.5C9.70848 5.27759 8.67447 5.7636 8.99986 6.5C9.2844 7.14396 10.0191 6.98569 10.4999 7.5C11.0962 8.13792 11.4999 9.5 11.4999 9.5",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.685488 5.23214C1.13649 5.23214 1.43105 5.21234 1.88177 5.23206C2.20525 5.24621 2.50265 5.28432 2.74881 5.5081C2.99417 5.73115 3.12919 5.99487 3.26549 6.2902C3.54441 6.89451 3.61258 7.61685 3.97682 8.17646C4.30452 8.67993 4.85 8.94454 5.36763 9.20806C5.87701 9.46738 6.32689 9.80767 6.78497 10.1459C7.09907 10.3778 7.3943 10.6118 7.62901 10.9262C7.73609 11.0697 8.35295 11.9265 8.49999 12",
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExplore);
export default __webpack_public_path__ + "static/media/Explore.50c061a8.svg";
export { ForwardRef as ReactComponent };